import styled, { keyframes } from "styled-components";

const spin = keyframes`
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }

`

export const Spinner = styled.div`
    width: ${({ size }) => size}px;
    height: ${({ size }) => size}px;

    border-width: ${({ borderSize }) => borderSize}px;
    border-style: solid;
    border-radius: 50%;
    border-color: transparent;
    border-bottom-color: ${({ theme }) => (theme.colors.primary)};

    animation: 1s ${spin} linear infinite;

`
